<template>
  	<div style="border-left:2px dashed var(--border);width:0;height:40px;margin:0 5px;"></div>
</template>

<script>
export default {

};
</script>
